var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-with-pagination',{attrs:{"tableData":_vm.targetLists,"columnList":_vm.columnList,"pagination":_vm.pagination,"maxHeight":"400px"},on:{"update:pagination":function($event){_vm.pagination=$event},"size-change":_vm.getTargetList,"current-change":_vm.getTargetList}})
}
var staticRenderFns = []

export { render, staticRenderFns }